
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80","viewBox":"0 0 96.95 96.95"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"5","data-name":"report 2"}},[_c('path',{attrs:{"d":"M32.317 8.099v12.149"}}),_c('path',{attrs:{"data-name":"Vector","d":"M64.633 8.099v12.149M64.939 14.174c13.441.727 20.182 5.853 20.182 24.825v24.947c0 16.631-4.036 24.946-24.218 24.946H36.686c-20.182 0-24.218-8.318-24.218-24.946V38.999c0-18.972 6.741-24.058 20.181-24.825z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M71.423 38.781L50.005 60.203l-8.161-12.241-16.321 16.319"}}),_c('path',{attrs:{"data-name":"Vector","d":"M61.221 38.783h10.2v10.2"}})])])
          )
        }
      }
    